//It also supports IE with window.msCrypto !!!!!!
import { Crypto } from '@openid/appauth/built/crypto_utils';
import { AppAuthError } from "@openid/appauth/built/errors";
import * as base64 from 'base64-js';

const CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export class NucleusCrypto implements Crypto {
  private browserCrypto = window.crypto || (<any>window).msCrypto;

  generateRandom(size: number) {
    const buffer = new Uint8Array(size);
    if (this.browserCrypto) {
      this.browserCrypto.getRandomValues(buffer);
    } else {
      // fall back to Math.random() if nothing else is available
      for (let i = 0; i < size; i += 1) {
        buffer[i] = Math.random();
      }
    }
    return this.bufferToString(buffer);
  }

  deriveChallenge(code: string): Promise<string> {
    if (code.length < 43 || code.length > 128) {
      return Promise.reject(new AppAuthError('Invalid code length.'));
    }
    if (!this.browserCrypto.subtle) {
      return Promise.reject(new AppAuthError('window.crypto.subtle is unavailable.'));
    }

    var ecode = this.textEncodeLite(code)
    var op = this.browserCrypto.subtle.digest('SHA-256', ecode)
    return new Promise((resolve, reject) => {
      if (op.algorithm) { //if operation contains algorithm it means it is not a promise which means it is CryptoOperation from IE. Ve just return result as promise
        console.log("we have a CryptoOperation")
        op.addEventListener("complete", () => {
          resolve(this.urlSafe(op.result));
        });

        op.addEventListener("error", () => {
          reject(op.result);
        })
      }
      else { // the result is promise
        op.then(buffer => resolve(this.urlSafe(buffer)), error => reject(error));
      }
    });
  }


  private urlSafe(buffer: Uint8Array): string {
    const encoded = base64.fromByteArray(new Uint8Array(buffer));
    return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  }

  private textEncodeLite(str: string) {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);

    for (let i = 0; i < str.length; i++) {
      bufView[i] = str.charCodeAt(i);
    }
    return bufView;
  }

  private bufferToString(buffer: Uint8Array) {
    let state = [];
    for (let i = 0; i < buffer.byteLength; i += 1) {
      let index = buffer[i] % CHARSET.length;
      state.push(CHARSET[index]);
    }
    return state.join('');
  }
}
